
import Loader from '../../utils/Loader';
 
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React , {useEffect} from "react";  /////
import { yupResolver } from "@hookform/resolvers/yup";
import {  useShowStudentQuery,useUpdateStudentMutation,useGetManagerListQuery } from "../../Services/api";
export default function UpdateStudent(props) {
    const notify = () => '';
    const validationSchema = Yup.object().shape({
        first_name: Yup.string().required("first name fields is required"),
        last_name: Yup.string().required("last name fields is required"),
        mobile_number: Yup.string().required("phone number fields is required"),
        email: Yup.string().required("email fields is required"),
        dob: Yup.string().required("date of birth fields is required"),
        mail_address: Yup.string().required("mail address fields is required"),
        // addition_email: Yup.string().required("addition email fields is required"),
        allocate_trainer: Yup.string().required("allocate trainer fields is required"),
    });
      const {
        data: showStudent,
        isLoading: isGetLoading,
      } =  useShowStudentQuery({  params:props['id']});
      const [updateStudent,isLoading] = useUpdateStudentMutation();
      const studentData= showStudent?.data[0];
     
      var  defaultValues={
        first_name:studentData?.first_name,
        last_name:studentData?.last_name,
        mobile_number:studentData?.mobile_number,
        email:studentData?.email,
        dob:studentData?.dob,
        mail_address:studentData?.mail_address,
        addition_email:studentData?.addition_email,
        allocate_trainer:studentData?.allocate_trainer,
    };
    const methods = useForm({
        mode: "onChange",
        resolver: yupResolver(validationSchema),
        defaultValues: defaultValues, 
    });
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
      } = methods;
       // eslint-disable-next-line react-hooks/exhaustive-deps 
      useEffect(() => {
        reset(defaultValues)
      },[studentData]) 
    const updateStudentList = (values,e) => {
        updateStudent({ data: values,param:props['id'] })
        .unwrap()
        .then((payload) => {
            if (payload.status) {
              toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
    const { 
        data: ManagerList        
    } = useGetManagerListQuery();

    if(isGetLoading) return  <Loader></Loader>
    return (
        
        <div className="modal fade" id="fullscreenModal">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update student</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <section className="section">
                    <div className="card">
                        <div className="card-body">
                        <h5 className="card-title">Update student</h5>
                        <form onSubmit={handleSubmit(updateStudentList)} >
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">first name</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("first_name")} className="form-control" />
                                <span className="text-danger">{errors.first_name?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">last name</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("last_name")} className="form-control" />
                                <span className="text-danger">{errors.last_name?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">mobile number</label>
                            <div className="col-sm-10">
                                <input type="number" {...register("mobile_number")} className="form-control" />
                                <span className="text-danger">{errors.mobile_number?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">email</label>
                            <div className="col-sm-10">
                                <input type="email" {...register("email")} className="form-control" />
                                <span className="text-danger">{errors.email?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">date fo birth</label>
                            <div className="col-sm-10">
                                <input type="date" {...register("dob")} className="form-control" />
                                <span className="text-danger">{errors.dob?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">mail address</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("mail_address")} className="form-control" />
                                <span className="text-danger">{errors.mail_address?.message}</span>
                            </div>
                        </div>
                       
                       
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">addition email</label>
                            <div className="col-sm-10">
                                <input type="email" {...register("addition_email")} className="form-control" />
                                <span className="text-danger">{errors.addition_email?.message}</span>
                            </div>
                        </div>  
                        <div className="row mb-3">
                            <label htmlFor="inputEmail" className="col-sm-2 col-form-label">Select allocate trainer</label>
                            <div className="col-sm-10">
                                <select  {...register("allocate_trainer")} className="form-control" >
                                {                            
                                ManagerList?.data?.map((item) => {
                                    return (
                                        <option key={item.teacher_id} value={item.teacher_id}>{item.name}</option>                                           
                                        )
                                    })
                                }
                                </select>   
                                <span className="text-danger">{errors.allocate_trainer?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputEmail" className="col-sm-2 col-form-label">Select gender</label>
                            <div className="col-sm-10">
                                <select  {...register("gender")} className="form-control" >
                                <option value="male">male</option> 
                                <option value="female">female</option> 
                                </select>   
                            </div>
                        </div>
                        <div className="modal-footer">
                                {isLoading.status !='pending' ? 
                                                
                                    <>
                                    <button type="submit" className="btn btn-warning" data-bs-dismiss="modal">Save changes</button>
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    </>
                                   :
                                    <button type="submit" className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                 }
                                         
                            </div> 
                        </form>
                        </div>
                    </div>
                </section>
            </div>
          </div>
        </div>
        </div>
    );
}